var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LogoAndHeading } from '@/components/logo-and-heading.component';
import { Typography } from '@mui/material';
import { pageImages } from './images';
import { SideImageLayout } from 'hx-ui';
import { Footer } from '@/components/footer.component';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { useGetPreviousPath } from '@/hooks/use-get-previous-path.hook';
export var DisclaimerPage = function () {
    var previousPath = useGetPreviousPath().previousPath;
    return (_jsx(SideImageLayout, { header: _jsx(LogoAndHeading, { headingText: 'Disclaimer', className: "mt-10 text-lg md:text-2xl font-bold" }), imageLeft: pageImages.forest, leftPanelWidth: "40%", content: _jsx(Typography, __assign({ variant: "body1", className: "w-[70%] text-dark-text" }, { children: "The hearing screener is not a replacement for a medical service. The Food and Drug Administration (FDA) has determined that it is in your best health interest to have a medical evaluation by a physician, preferably one specializing in diseases of the ear, before purchasing a hearing aid. The information and Services supplied are not a substitute for a visit to a medical professional, and you are advised that you should consult a physician or healthcare professional before making any medical decisions." })), nav: _jsx(NavigationButtonsContainer, __assign({ className: 'pb-10' }, { children: _jsx(NavigationButton, { navigate: previousPath, label: "Previous" }) })), footer: _jsx(Footer, {}) }));
};
